import classNames from "classnames";
import { Button } from "../Button";
import { useSelector } from "react-redux";

import {
  getFacebookShareLink,
  getTelegramShareLink,
  getTwitterShareLink,
  getWhatsAppShareLink,
  openInPopupByEvent,
  shareFunctionsMap,
} from "@helpers/share";
import { ReactComponent as IconTelegram } from "../../assets/ic-telegram.svg";
import { ReactComponent as IconWhatsApp } from "../../assets/ic-whats-app.svg";
import { ReactComponent as IconFB } from "../../assets/ic-fbook.svg";

import styles from "./index.module.scss";
import TwitterIcon from "../TwitterIcon";
import React from "react";

const popupButtonConfig = {
  tag: "a",
  target: "popup",
  onClick: openInPopupByEvent,
};

const ShareSocials = ({
  username,
  type = "post",
  creatorUniqueKey,
  postUniqueKey,
  subscriptionUniqueKey,
  message = "",
  streamUniqueKey,
  contentOwnerKey,
}) => {
  const { newFanReferralCode, newCreatorReferralCode } = useSelector(
    ({ profileReducer }) => profileReducer,
  );
  const shareLinkParams = {
    username,
    creatorUniqueKey,
    postUniqueKey,
    streamUniqueKey,
    contentOwnerKey,
    subscriptionUniqueKey,
    referralCode: newFanReferralCode,
    newCreatorReferralCode,
  };

  const shareFunction = shareFunctionsMap[type];

  const shareLink = shareFunction(shareLinkParams);

  const telegramShareLink = getTelegramShareLink(
    encodeURIComponent(shareLink),
    message,
  );
  const twitterShareLink = getTwitterShareLink(
    encodeURIComponent(shareLink),
    message,
  );
  const whatsAppShareLink = getWhatsAppShareLink(
    encodeURIComponent(shareLink),
    message,
  );
  const facebookShareLink = getFacebookShareLink(
    encodeURIComponent(shareLink),
    message,
  );

  return (
    <div className={classNames("d-flex", styles.socials)}>
      <Button
        {...popupButtonConfig}
        href={facebookShareLink}
        className={classNames("rounded-small", styles.btn)}
      >
        <IconFB width="20" height="20" className="text-primary" />
      </Button>
      <Button
        {...popupButtonConfig}
        href={twitterShareLink}
        className={classNames("rounded-small", styles.btn)}
      >
        <TwitterIcon
          oppositeColor
          width="20"
          height="20"
          className="text-primary"
        />
      </Button>
      <Button
        {...popupButtonConfig}
        href={whatsAppShareLink}
        className={classNames("rounded-small", styles.btn)}
      >
        <IconWhatsApp width="20" height="20" className="text-primary" />
      </Button>
      <Button
        {...popupButtonConfig}
        href={telegramShareLink}
        className={classNames("rounded-small", styles.btn)}
      >
        <IconTelegram width="20" height="20" className="text-primary" />
      </Button>
    </div>
  );
};

export default ShareSocials;
